export default __webpack_public_path__ + "static/media/Four.d4e0bde4.svg";